// let clickedProductId = "";
// const submitButtons = document.querySelectorAll('.product-form__submit');
// function removeSpinner() {
//   submitButtons.forEach(button => {
    
//     let spinnerElement = button.querySelector('.loading-overlay__spinner');
//     if (spinnerElement) {
//       spinnerElement.classList.add('hidden');
//     }
//     let spanElement = button.querySelector('span');
//     if (spanElement) {
//       spanElement.classList.remove('hidden-text');
//     }
//     button.disabled = false;
//   });
// }

// function appendErrorTextMsg (errorMsg) {
//   const newPTag = document.createElement('p');
//   const divContainer = document.createElement('div');
//   divContainer.classList.add('error-msg');
//   divContainer.style.color = "red";
//   if(errorMsg){
//     newPTag.textContent = errorMsg;
//   }else{
//     newPTag.textContent = 'Sorry, Unable to add product in cart. Please try after clearing your cart again.';
//   }
//   divContainer.appendChild(newPTag);
//   if (window.location.href.includes('/products')) {
//     document.querySelector('.product-form__buttons').insertAdjacentElement('afterend', divContainer);
//     document.querySelector('.product-form__buttons').removeAttribute('disabled');
//   }

//   setTimeout(function () {
    
//     let elementsToRemove = document.querySelectorAll('.error-msg');
//     if (elementsToRemove) {
//       elementsToRemove.forEach(element => {
//         element.remove();
//       });
//     }
//   }, 5000)
// }

// submitButtons.forEach(button => {
//   button.addEventListener('click', function (event) {
//     document.querySelectorAll('product-card-model').forEach(model => {
//         model.style.display = 'block';
//         let modalElement = model.querySelector('.show__modal');
//         if (modalElement) {
//             modalElement.classList.remove('show__modal');
//         }
//     });
//     removeSpinner();
//     let elementsToRemove = document.querySelectorAll('.error-msg');
//     if (elementsToRemove) {
//       elementsToRemove.forEach(element => {
//         element.remove();
//       });
//     }

//     let spinnerElement = button.querySelector('.loading-overlay__spinner');
//     if (spinnerElement) {
//       spinnerElement.classList.add('hidden');
//     } else {
//       console.error("Spinner element not found within the button.");
//     }
    
//     let elementsToRemoveClass = document.querySelectorAll('.recentlyClikedBtn');
//     if (elementsToRemove) {
//       elementsToRemove.forEach(element => {
//         element.disabled = false;
//         element.classList.remove('recentlyClikedBtn');
//       });
//     }
//     const dataProductId = event.target.getAttribute('data-product-id') || event.target.closest('.product-form__submit').getAttribute('data-product-id');
//     let productCardModelDataProductId = document.querySelector(`product-card-model[data-product-id='${dataProductId}']`);
//     if(productCardModelDataProductId){
//       productCardModelDataProductId.style.display = 'none';
//     }
//     getCartUpdate(dataProductId);
//     if (dataProductId != null) {
//       clickedProductId = dataProductId;
//     }
//     event.target.closest('.product-form__submit').removeAttribute('disabled');
//   });
// });

// customElements.define('card-product-slider', class cardProductSlider extends HTMLElement {
//   constructor() {
//     super();
//     this.swiperElemet = this.querySelector('.swiper');
//     this.totalPages = parseInt(this.dataset.totalPages);
//     this.collectionUrl = this.dataset.url;
//     this._makePaginate();
//     this._radioChangeAction();
    
//   }
//   async _makePaginate(){
//    if(this.totalPages == 1){
//      if(this.closest('product-card-model').isOpen) this._init();
//      this.swiperElemet.closest('.js-step--wrapper').classList.remove('loading');
//      return;
//    }
//     this.swiperElemet.closest('.js-step--wrapper').classList.add('loading');
//     for (let index = 2; index <= this.totalPages; index++) {
//       let responce = await fetch(`${this.collectionUrl}?page=${index}&section_id=product-gift-card-collection-products`);
//       let data = await responce.text();
//       let html = new DOMParser().parseFromString(data, 'text/html').querySelector('card-product-slider');
//       this.querySelector('.swiper-wrapper').insertAdjacentHTML("beforeend", html.querySelector('.swiper-wrapper').innerHTML);
//     }
//     this.swiperElemet.closest('.js-step--wrapper').classList.remove('loading');
//     if(this.closest('product-card-model').isOpen) this._init();
//     this._radioChangeAction();
//   }
//   _init(){
//     new Swiper(this.swiperElemet, {
//       slidesPerView: 1,
//       navigation: {
//         nextEl: '.model-swiper-button-next',
//         prevEl: '.model-swiper-button-prev',
//       }
//     });
//   }
//   _radioChangeAction(){
//     this.querySelectorAll('[type="radio"][name="id"]').forEach(radio => {
//       // console.log(1,radio)
//       if(radio.classList.contains('js-event-added')) return;
//       radio.classList.add('js-event-added');
//       radio.onchange = (event) => {
//         let button = radio.closest('.js-step--wrapper').querySelector('.btn-next-prev');
//         button.disabled = false;
//         button.classList.remove('disabled');
//       };
//     });
//   }
// });

// customElements.define('product-card-model', class productCardModel extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('.btn-next-prev').forEach(button => this._nextPrevAction(button));
//     this.querySelector('.modal-close-button').onclick = () => this._close();
//     this.querySelector('.js-tag-filter').onchange = (event) => this._filter(event);
//     this.isOpen = false;
//     this.catchFilter = [];
//   }
  
//   _nextPrevAction(button){
//     button.onclick = (event) => {
//       let perentElement = button.closest('.js-step--wrapper');
//       perentElement.classList.add('hidden');
//       if(button.dataset.action == "next"){
//         perentElement.nextElementSibling.classList.remove('hidden');
//       }else{
//         perentElement.previousElementSibling.classList.remove('hidden');
//       }
//       setTimeout(() => {
//         minHeight('.upcell-product-item', '.item-title');
//       }, 50)
//     };
//   }
//   _open(){   
//     this.querySelector('.quick__shop--modal').classList.add('show__modal');
//     this.querySelector('card-product-slider')._init();
//     (window.sessionStorage.getItem('giftMessage') && (this.querySelector('[name="properties[Message]"]').value = atob(window.sessionStorage.getItem('giftMessage'))));
//     this.isOpen = true;
//     minHeight('.upcell-product-item', '.item-title');
//     let productId = this.getAttribute("data-product-id");
//     // console.log("productId", productId)

//     fetch(window.location.pathname)
//       .then(response => response.text())
//       .then(data => {
//         const tempElement = document.createElement('div');
//         tempElement.innerHTML = data;
//         const targetProductModel = tempElement.querySelector(`product-card-model[data-product-id="${productId}"]`);
//          if (targetProductModel) {
//           const existingProductModel = document.querySelector(`product-card-model[data-product-id="${productId}"]`);
//           if (existingProductModel) {
//             const sectionStepFour = existingProductModel.querySelector('.section-step-four');
//             if (sectionStepFour) {
//               sectionStepFour.innerHTML = targetProductModel.querySelector('.section-step-four').innerHTML;
//               const sectionStepFourElements = document.querySelectorAll(".section-step-four");
//                 sectionStepFourElements.forEach(sectionStepFour => {
//                 const addButtons = sectionStepFour.querySelectorAll(".add-upcell.button");
//                 const quantityInputs = sectionStepFour.querySelectorAll(".added-message");
              
//                 quantityInputs.forEach(input => {
//                   input.style.display = "none";
//                 });
              
//                 addButtons.forEach((addButton, index) => {
//                   addButton.addEventListener("click", function(event) {
//                     event.preventDefault();
//                     addButton.style.display = "none";
//                     quantityInputs[index].style.display = "flex";
//                   });
//                 });
                
//                 sectionStepFour.querySelector('.btn-next-prev').addEventListener('click', () => {
//                   const stepThree = targetProductModel.querySelector('.section-step-three');
//                   const stepFour = targetProductModel.querySelector('.section-step-four');
                  
//                   if (stepThree && stepFour) {
//                       stepThree.classList.toggle('hidden');
//                       stepFour.classList.toggle('hidden');
//                   }
//                 });
//                 this.querySelectorAll('.btn-next-prev').forEach(button => this._nextPrevAction(button));
//               });
//               if(!document.querySelector(".upcell-items-slider").classList.contains(".swiper-initialized")){
//                 var popupSwiperSlider = new Swiper('.upcell-items-slider', {
//                   slidesPerView: 3,
//                   spaceBetween: 25,
//                   loop: false,
//                   pagination: {
//                     el: ".swiper-pagination",
//                     clickable: true,
//                     type: "fraction",
//                   }, 
//                   navigation: {
//                     nextEl: '.swiper-button-next',
//                     prevEl: '.swiper-button-prev',
//                   },
//                   scrollbar: {
//                     el: '.swiper-scrollbar',
//                     draggable: true
//                   }
//                 });
//               }
//             }
//           }
//          }
//       })
//       .catch(error => console.error(error));
//   }
//   _close(reset = false){
//     this.querySelector('.quick__shop--modal').classList.remove('show__modal');
//     this.querySelector('card-product-slider').swiperElemet.swiper.destroy();
//     window.sessionStorage.removeItem("productData");
//     if(reset){
//       this.querySelector('.js-step--wrapper:not(.hidden)').classList.add('hidden');
//       let firstStep = this.querySelector('.js-step--wrapper');
//       firstStep.classList.remove('hidden');
//       firstStep.querySelector('input[type=radio]:checked').checked = false;
//       firstStep.querySelector('.btn-next-prev').disabled = true;
//       firstStep.querySelector('.btn-next-prev').classList.add('disabled');
//     }
//     this.isOpen = false;
//   }
//   _filter(){
//     let select = event.currentTarget,
//         wrapper = select.closest('.js-step--wrapper'),
//         url = select.value;
//     wrapper.classList.add('loading');
//     const filterDataUrl = element => element.url === url;

//     this.catchFilter.some(filterDataUrl) ? this._renderFromCatch(url,select) : this._renderFromFetch(url,select);
//   }
//   _renderFromCatch(url,select){
//     let element = this.catchFilter.find(element => {
//       return (element.url === url)
//     });
//     this._renderFilterData(element.data,select);
//   }
//   _renderFromFetch(url,select){
//     fetch(`${url}?section_id=product-gift-card-collection-products`)
//     .then(responce => {
//       return responce.text();
//     })
//     .then(data => {
//       this.catchFilter = [...this.catchFilter, { data, url }];
//       this._renderFilterData(data,select);
//     });
//   }
//   _renderFilterData(html,select){
//     let newHTML = new DOMParser().parseFromString(html, 'text/html'),
//         wrapper = select.closest('.js-step--wrapper'),
//         button = wrapper.querySelector('.btn-next-prev');
//     wrapper.querySelector('card-product-slider').replaceWith(newHTML.querySelector('card-product-slider'));
//     button.disabled = true;
//     button.classList.add('disabled');
//   }
// });

// customElements.define('product-form', class ProductForm extends HTMLElement {
//   constructor() {
//     super();   

//     this.form = this.querySelector('form');
//     if (this.form){
      
//     this.form.addEventListener('submit', (event) => {event.preventDefault();});
//     this.cartDrawer = document.querySelector('cart-drawer');
//     }
//   }

//   onSubmitHandle(evt) {
//     evt.preventDefault();

//     const submitButton = this.querySelector('[type="submit"]');
//     let cartModel = document.querySelector(`product-card-model[data-product-id="${submitButton.dataset.productId}"]`) || submitButton.closest('product-card-model');

//     if(submitButton.hasAttribute('data-collectionurl') == false){
//       submitButton.setAttribute('disabled', true);
//       submitButton.classList.add('loading');
//     }

//     if(window.addCandyOnSubmit){
//       let productInfoWrapper = document.querySelector(".product__info-wrapper");
//       let candySelectionLimit = window.selectionNum ?? 3;
//       let childCustomCandyInputs = productInfoWrapper.querySelectorAll("input[type='checkbox']:checked");
//       let totalCount = 0;
//       childCustomCandyInputs.forEach(function (element) {
//         let closestProductContent = element.closest(".product__content");
//         if (closestProductContent) {
//           let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
//           if (candyQtySelector) {
//             totalCount += Number(candyQtySelector.value);
//           }
//         }
//       });
      
//       if (totalCount < candySelectionLimit) {
//         if (productInfoWrapper) {
//           let existingError = productInfoWrapper.querySelector(".error-msg-validation");
//           let productFormButtons = productInfoWrapper.querySelector(".product-form__buttons");
//           productFormButtons.remove();
//           if (existingError) existingError.remove();
      
//           // Create and insert the error message
//           const errorMsgValidation = document.createElement("div");
//           errorMsgValidation.className = "error-msg-validation";
//           errorMsgValidation.style.color = "red";
//           errorMsgValidation.style.marginTop = "10px";
//           errorMsgValidation.textContent = `You must select at least ${candySelectionLimit} candies to purchase this item.`;
      
//           productFormButtons.insertAdjacentElement("afterend", errorMsgValidation);
//           // Clear after 5 seconds
//           setTimeout(() => {
//             errorMsgValidation.remove();
//           }, 5000);
//         }
//         return;
//       }
//     }

//     window.submitButtonReplace = submitButton.classList.contains('js-drawer-card');
    
//     let body = JSON.stringify({
//       ...JSON.parse(serializeForm(this.form)),
//       sections: this.getSectionsToRender().map((section) => section.section),
//       sections_url: window.location.pathname
//     });

//     let id = this.form.id.value
//     const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
//     productForms.forEach((productForm) => {
//       if(productForm.querySelectorAll('.main-id').length){
//          productForm.querySelectorAll('.main-id').forEach(function(elm){
//            if(elm.value){
//              id = elm.value 
//            } 
//          })
//       }
//     });

//     if(submitButton.hasAttribute('data-collectionurl') == true){
//       let productData = {
//           id: id,
//           quantity: (this.form.quantity) ? this.form.quantity.value : 1,
//           productName: submitButton.getAttribute('data-productTitle')
//        };
//       // console.log("productData", productData)
//       window.sessionStorage.setItem("productData", JSON.stringify(productData));
//       cartModel._open();
      
//       return;
//     }
//     // console.log("productForms", productForms)
//     if(submitButton.hasAttribute('modal-form-cards') == true && window.sessionStorage.getItem("productData") != null){
//       let cardsProductData = JSON.parse(window.sessionStorage.getItem("productData")),
//           currentProductData = JSON.parse(serializeForm(this.form)),
//           items = {},
//           curentTime = new Date().getTime();
//       if(currentProductData.properties){
//         currentProductData.properties._uniq_id = curentTime;
//       } else{
//         currentProductData.properties = {};
//         currentProductData.properties._uniq_id = curentTime;
//       }
//       currentProductData.properties.for = cardsProductData.productName;

//       let shipping_interval_unit_type = document.querySelector('[name="properties[shipping_interval_unit_type]"]') ? document.querySelector('[name="properties[shipping_interval_unit_type]"]').value : '';
//       let shipping_interval_frequency = document.querySelector('[name="properties[shipping_interval_frequency]') ? document.querySelector('[name="properties[shipping_interval_frequency]').value : '';
//       if(shipping_interval_unit_type && shipping_interval_frequency){
//         // currentProductData.properties.shipping_interval_unit_type = shipping_interval_unit_type 
//         // currentProductData.properties.shipping_interval_frequency = shipping_interval_frequency 
//       }
//       let selling_plan = document.querySelector("select[name='selling_plan']") ? document.querySelector("select[name='selling_plan']").value : '';

//       items.items = [
//         currentProductData,
//         {
//           id: cardsProductData.id,
//           quantity: cardsProductData.quantity,
//           selling_plan: selling_plan,
//           properties: {
//             _main_product: curentTime,
//             With:submitButton.form.querySelector('[name="id"]:checked').dataset.title,
//             shipping_interval_unit_type: shipping_interval_unit_type, 
//             shipping_interval_frequency: shipping_interval_frequency
//           }
//         }
//       ];

//       // console.log("items.items===", items.items)

//       const sectionStepFourElements = document.querySelectorAll(".section-step-four");
//       sectionStepFourElements.forEach(sectionStepFour => {
//         if (window.getComputedStyle(sectionStepFour).display !== 'none') {
//           let quantityInputs = sectionStepFour.querySelectorAll(".added-message");
//           quantityInputs.forEach(quantityInput => {
//             if (window.getComputedStyle(quantityInput).display !== 'none') {
//               let idInput = quantityInput.parentElement.querySelector('input[name="id"]');
//               let id = idInput.value;
//               let quantity = 1;
//               // let properties = {'_upsell' : true};
//               let properties = {'_upsell' : true, 'For': cardsProductData.productName, '_uniq_var_id': curentTime}
//               items.items.push({ id, quantity, properties });
//             }
//           });
//         }
//       });

//       if(window.addCandyOnSubmit){
//         let upsellArray = [];
//         window.candyVariantIds.forEach(id => {
//           let idExists = upsellArray?.some(product => product.id === id);
//           if(!idExists){
//             let candyQty = 1;
//             let candyQtySelector = document.querySelector(`[name="candy__qty--selector-${id}"]`);
//             if(candyQtySelector){
//               candyQty = Number(candyQtySelector.value);
//             }
//             let obj = {
//               'id': id,
//               'quantity': candyQty,
//               'properties' : {'_upsell' : true, 'For': cardsProductData.productName, '_uniq_var_id': curentTime, '_eligible_candy' : true}
//             }
//             upsellArray.push(obj)
//           }
//           if(window.specificUpsellData == null){
//             window.specificUpsellData = upsellArray;
//           }else{
//             window.specificUpsellData = [...window.specificUpsellData, ...upsellArray];
//           }
//         });
//       }
      
//       if (window.specificUpsellData && window.specificUpsellData.length > 0) {
//         let propertiesData = {
//           '_upsell': true,
//           'For': cardsProductData.productName,
//           '_uniq_var_id': curentTime
//         };
      
//         window.specificUpsellData.forEach(obj => {
//           let objId = obj?.id;
//           let foundObject = items.items?.find(item => item.id == objId);
//           if(foundObject){
//             let updateData = {
//               quantity: foundObject?.quantity ?? 2
//             };
//             Object.assign(foundObject, updateData);
//           }else{
//             if (!obj.properties) {
//               obj.properties = {};
//             }
//             Object.assign(obj.properties, propertiesData);
//             items.items.push({ ...obj });
//           }
          
//         });
//       }
      

//       items.sections = this.getSectionsToRender().map((section) => section.section);
//       items.sections_url = window.location.pathname;
//       body = JSON.stringify(items);

//     }

       
    
//     fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
//       .then((response) => response.json())
//       .then((parsedState) => {
//         /*fetch('/cart.js')
//         .then(response => response.json())
//         .then(cartData => {
//             var setsproductcount = 0;
//             var flowerCount = 0;
//             const cartItems = cartData.items;
//             cartItems.forEach(item => {
//             const { product_id, title, price, quantity, handle } = item;
//             if(handle == 'the-fresh-set' || handle == 'the-candle' || handle == 'the-perfume' || handle == 'the-hand-cream'){
//               setsproductcount++;
//             }
//             if(handle == 'the-send' || handle == 'tulips' || handle == 'roses' || handle == 'lilies'){
//               flowerCount++;
//             }
//             })
//             document.querySelectorAll('.product__list-container .product-grid__item').forEach((item) => {
//               let findButton = item.querySelector('product-form button'),
//                   findCollectionSingle = findButton.getAttribute('collection-collectionsingle'),
//                   findCollectionFreshset = findButton.getAttribute('collection-collectionfreshset'),
//                   findCollectionFlowers = findButton.getAttribute('collection-collectionflowers')
//               if(setsproductcount > 0 && findCollectionSingle == 'false' && findCollectionFreshset == 'false'){
//                 findButton.setAttribute('disabled','disabled')
//               }
//             if(flowerCount > 0 && findCollectionFlowers == 'false'){
//                 findButton.setAttribute('disabled','disabled')
//               }
//             })
//         })
//         .catch(error => {
//           console.log('Error fetching cart data:', error);
//         });*/
//         // console.log("parsedState", parsedState)
//         if(parsedState?.status == 422){
//           appendErrorTextMsg(parsedState?.description);
//         }else{
          
//           this.getSectionsToRender().forEach((section => {
//             // console.log("section.section", parsedState?.sections[section.section])
//             // console.log("section.selector", section.selector)
//             const elementToReplace =
//               document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//               elementToReplace.innerHTML =
//               this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
//           })); 
//         }
        
    
        
//       })
//       .catch((e) => {
//         console.error("error", e);
//         // appendErrorTextMsg(e.);
        
//       })
//       .finally(() => {
//         window.updateCartAttribute();
//         submitButton.classList.remove('loading');
//         submitButton.removeAttribute('disabled');
//         // this.cartDrawer.open();
//         if(cartModel) cartModel._close(true);
//         window.sessionStorage.removeItem("productData");
//         window.sessionStorage.removeItem('giftMessage');
        
//         fetch('/cart.js')
//         .then(response => response.json())
//         .then(cartData => {
          
//           const cartItems = cartData.items;
//           var ShowFreshsetMessage = false;
//           var TheCandleAdded = false;
//           var ThePerfumeAdded = false;
//           var TheHandCreamAdded = false;
//           let cartUpdate = {},
//               cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          
//           cartItems.forEach(item => {
//               if (item.product_id === 7186335367204){
//                 cartUpdate[item.key] = 0;
//                   TheCandleAdded = true;
//               }
//               if (item.product_id === 7186335891492){
//                 cartUpdate[item.key] = 0;
//                   ThePerfumeAdded = true;
//               }
//               if (item.product_id === 7186335957028){
//                 cartUpdate[item.key] = 0;
//                   TheHandCreamAdded = true;
//               }
            
//               if(TheCandleAdded == true && ThePerfumeAdded == true){
//                 ShowFreshsetMessage = true;
//               }else if(ThePerfumeAdded == true && TheHandCreamAdded == true){
//                 ShowFreshsetMessage = true;
//               }else if(TheHandCreamAdded == true && TheCandleAdded == true){
//                 ShowFreshsetMessage = true;
//               }
           
//           });

//           if(ShowFreshsetMessage == true && window.submitButtonReplace == true){
//             let items = {
//               updates: cartUpdate,
//               sections: this.getSectionsToRender().map((section) => section.section)
//             };
            
//              // console.log('update::',items);
//             // return;
//             fetch('/cart/update.js', {
//             method: 'POST',
//             credentials: 'same-origin',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'X-Requested-With': 'XMLHttpRequest'
//             },
//             body: JSON.stringify(items)
//             }).then(function(data) {
//               return data.json();
//             }).then(responce => {
//               this.getSectionsToRender().forEach((section => {
//                 const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//                 if(elementToReplace) elementToReplace.innerHTML = this.getSectionInnerHTML(responce.sections[section.section], section.selector);
//             }));
//             }).catch(function(error) {
//               console.error('Request failed', error)
//             })
//             .finally(() => {
//               window.updateCartAttribute();
//               // cart.disableLoading(ele.dataset.index);
//               let submitBtn = document.querySelector('.product-form__buttons');
//               // console.log("submitBtn", submitBtn)
//               if(submitBtn){
//                 submitBtn.querySelector('.product-form__submit').removeAttribute('disabled');
//                 submitBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
//                 submitBtn.querySelector('span').classList.remove('hidden-text');
//                 window.specificUpsellData = null;
//                 window.candyVariantIds = [];
//                 candyInputDeselectListener();
//                 let giftProductAdded = document.querySelectorAll(".gift__product--added");
//                 giftProductAdded.forEach(function(ele){
//                    ele.classList.remove("gift__product--added");
//                 });
//               }
//             });
//           }
//           var timestamp = new Date().getTime();
//           setCookie("cartTimestamp", timestamp, 2);
//         })
//         .finally(() => {
//             window.updateCartAttribute();
//             let submitBtn = document.querySelector('.product-form__buttons');
//             // console.log("submitBtn", submitBtn)
//             if(submitBtn){
//               submitBtn.querySelector('.product-form__submit').removeAttribute('disabled');
//               submitBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
//               submitBtn.querySelector('span').classList.remove('hidden-text');
//             }
//         })
//       });

//       if(clickedProductId){
//         document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').querySelector('.loading-overlay__spinner').classList.remove('hidden');
//         document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').querySelector('span').classList.add('hidden-text');
//         document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').disabled = true;
//         // var circleElement = document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').querySelector('.loading-overlay__spinner svg .path');
//         // if (circleElement) {
//         //     circleElement.style.stroke = '#000';
//         // }
//       }

//       setTimeout(function () {
//         let recentlyClidecBtn;
//         if(clickedProductId){
//           recentlyClidecBtn = document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]');
//         }
//         getCart(true, recentlyClidecBtn, clickedProductId);
//       }, 2000)
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer__content',
//         section: document.getElementById('cart-drawer__content').dataset.id,
//         selector: '.cart-drawer__content',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section'
//       }
//     ];
//   }

//   getSectionInnerHTML(html, selector) {
//     return new DOMParser()
//       .parseFromString(html, 'text/html')
//       .querySelector(selector).innerHTML;
//   }

//   handleErrorMessage(errorMessage = false) {
//     this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//     this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//     this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//     if (errorMessage) {
//       this.errorMessage.textContent = errorMessage;
//     }
//   }
// });

let clickedProductId = "";
const submitButtons = document.querySelectorAll('.product-form__submit');
function removeSpinner() {
  submitButtons.forEach(button => {
    
    let spinnerElement = button.querySelector('.loading-overlay__spinner');
    if (spinnerElement) {
      spinnerElement.classList.add('hidden');
    }
    let spanElement = button.querySelector('span');
    if (spanElement) {
      spanElement.classList.remove('hidden-text');
    }
    button.disabled = false;
  });
}

function appendErrorTextMsg (errorMsg) {
  const newPTag = document.createElement('p');
  const divContainer = document.createElement('div');
  divContainer.classList.add('error-msg');
  divContainer.style.color = "red";
  if(errorMsg){
    newPTag.textContent = errorMsg;
  }else{
    newPTag.textContent = 'Sorry, Unable to add product in cart. Please try after clearing your cart again.';
  }
  divContainer.appendChild(newPTag);
  if (window.location.href.includes('/products')) {
    document.querySelector('.product-form__buttons').insertAdjacentElement('afterend', divContainer);
    document.querySelector('.product-form__buttons').removeAttribute('disabled');
  }

  setTimeout(function () {
    
    let elementsToRemove = document.querySelectorAll('.error-msg');
    if (elementsToRemove) {
      elementsToRemove.forEach(element => {
        element.remove();
      });
    }
  }, 5000)
}

submitButtons.forEach(button => {
  button.addEventListener('click', function (event) {
    document.querySelectorAll('product-card-model').forEach(model => {
        model.style.display = 'block';
        let modalElement = model.querySelector('.show__modal');
        if (modalElement) {
            modalElement.classList.remove('show__modal');
        }
    });
    removeSpinner();
    let elementsToRemove = document.querySelectorAll('.error-msg');
    if (elementsToRemove) {
      elementsToRemove.forEach(element => {
        element.remove();
      });
    }

    let spinnerElement = button.querySelector('.loading-overlay__spinner');
    if (spinnerElement) {
      spinnerElement.classList.add('hidden');
    } else {
      console.error("Spinner element not found within the button.");
    }
    
    let elementsToRemoveClass = document.querySelectorAll('.recentlyClikedBtn');
    if (elementsToRemove) {
      elementsToRemove.forEach(element => {
        element.disabled = false;
        element.classList.remove('recentlyClikedBtn');
      });
    }
    const dataProductId = event.target.getAttribute('data-product-id') || event.target.closest('.product-form__submit').getAttribute('data-product-id');
    let productCardModelDataProductId = document.querySelector(`product-card-model[data-product-id='${dataProductId}']`);
    if(productCardModelDataProductId){
      productCardModelDataProductId.style.display = 'none';
    }
    getCartUpdate(dataProductId);
    if (dataProductId != null) {
      clickedProductId = dataProductId;
    }
    event.target.closest('.product-form__submit').removeAttribute('disabled');
  });
});

customElements.define('card-product-slider', class cardProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperElemet = this.querySelector('.swiper');
    this.totalPages = parseInt(this.dataset.totalPages);
    this.collectionUrl = this.dataset.url;
    this._makePaginate();
    this._radioChangeAction();
    
  }
  async _makePaginate(){
   if(this.totalPages == 1){
     if(this.closest('product-card-model').isOpen) this._init();
     this.swiperElemet.closest('.js-step--wrapper').classList.remove('loading');
     return;
   }
    this.swiperElemet.closest('.js-step--wrapper').classList.add('loading');
    for (let index = 2; index <= this.totalPages; index++) {
      let responce = await fetch(`${this.collectionUrl}?page=${index}&section_id=product-gift-card-collection-products`);
      let data = await responce.text();
      let html = new DOMParser().parseFromString(data, 'text/html').querySelector('card-product-slider');
      this.querySelector('.swiper-wrapper').insertAdjacentHTML("beforeend", html.querySelector('.swiper-wrapper').innerHTML);
    }
    this.swiperElemet.closest('.js-step--wrapper').classList.remove('loading');
    if(this.closest('product-card-model').isOpen) this._init();
    this._radioChangeAction();
  }
  _init(){
    new Swiper(this.swiperElemet, {
      slidesPerView: 1,
      navigation: {
        nextEl: '.model-swiper-button-next',
        prevEl: '.model-swiper-button-prev',
      }
    });
  }
  _radioChangeAction(){
    this.querySelectorAll('[type="radio"][name="id"]').forEach(radio => {
      // console.log(1,radio)
      if(radio.classList.contains('js-event-added')) return;
      radio.classList.add('js-event-added');
      radio.onchange = (event) => {
        let button = radio.closest('.js-step--wrapper').querySelector('.btn-next-prev');
        button.disabled = false;
        button.classList.remove('disabled');
      };
    });
  }
});

customElements.define('product-card-model', class productCardModel extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.btn-next-prev').forEach(button => this._nextPrevAction(button));
    this.querySelector('.modal-close-button').onclick = () => this._close();
    this.querySelector('.js-tag-filter').onchange = (event) => this._filter(event);
    this.isOpen = false;
    this.catchFilter = [];
  }
  
  _nextPrevAction(button){
    button.onclick = (event) => {
      let perentElement = button.closest('.js-step--wrapper');
      perentElement.classList.add('hidden');
      if(button.dataset.action == "next"){
        perentElement.nextElementSibling.classList.remove('hidden');
      }else{
        perentElement.previousElementSibling.classList.remove('hidden');
      }
      setTimeout(() => {
        minHeight('.upcell-product-item', '.item-title');
      }, 50)
    };
  }
  _open(){   
    this.querySelector('.quick__shop--modal').classList.add('show__modal');
    this.querySelector('card-product-slider')._init();
    (window.sessionStorage.getItem('giftMessage') && (this.querySelector('[name="properties[Message]"]').value = atob(window.sessionStorage.getItem('giftMessage'))));
    this.isOpen = true;
    minHeight('.upcell-product-item', '.item-title');
    let productId = this.getAttribute("data-product-id");
    // console.log("productId", productId)

    fetch(window.location.pathname)
      .then(response => response.text())
      .then(data => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = data;
        const targetProductModel = tempElement.querySelector(`product-card-model[data-product-id="${productId}"]`);
         if (targetProductModel) {
          const existingProductModel = document.querySelector(`product-card-model[data-product-id="${productId}"]`);
          if (existingProductModel) {
            const sectionStepFour = existingProductModel.querySelector('.section-step-four');
            if (sectionStepFour) {
              sectionStepFour.innerHTML = targetProductModel.querySelector('.section-step-four').innerHTML;
              const sectionStepFourElements = document.querySelectorAll(".section-step-four");
                sectionStepFourElements.forEach(sectionStepFour => {
                const addButtons = sectionStepFour.querySelectorAll(".add-upcell.button");
                const quantityInputs = sectionStepFour.querySelectorAll(".added-message");
              
                quantityInputs.forEach(input => {
                  input.style.display = "none";
                });
              
                addButtons.forEach((addButton, index) => {
                  addButton.addEventListener("click", function(event) {
                    event.preventDefault();
                    addButton.style.display = "none";
                    quantityInputs[index].style.display = "flex";
                  });
                });
                
                sectionStepFour.querySelector('.btn-next-prev').addEventListener('click', () => {
                  const stepThree = targetProductModel.querySelector('.section-step-three');
                  const stepFour = targetProductModel.querySelector('.section-step-four');
                  
                  if (stepThree && stepFour) {
                      stepThree.classList.toggle('hidden');
                      stepFour.classList.toggle('hidden');
                  }
                });
                this.querySelectorAll('.btn-next-prev').forEach(button => this._nextPrevAction(button));
              });
              if(!document.querySelector(".upcell-items-slider").classList.contains(".swiper-initialized")){
                var popupSwiperSlider = new Swiper('.upcell-items-slider', {
                  slidesPerView: 3,
                  spaceBetween: 25,
                  loop: false,
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "fraction",
                  }, 
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true
                  }
                });
              }
            }
          }
         }
      })
      .catch(error => console.error(error));
  }
  _close(reset = false){
    this.querySelector('.quick__shop--modal').classList.remove('show__modal');
    this.querySelector('card-product-slider').swiperElemet.swiper.destroy();
    window.sessionStorage.removeItem("productData");
    if(reset){
      this.querySelector('.js-step--wrapper:not(.hidden)').classList.add('hidden');
      let firstStep = this.querySelector('.js-step--wrapper');
      firstStep.classList.remove('hidden');
      firstStep.querySelector('input[type=radio]:checked').checked = false;
      firstStep.querySelector('.btn-next-prev').disabled = true;
      firstStep.querySelector('.btn-next-prev').classList.add('disabled');
    }
    this.isOpen = false;
  }
  _filter(){
    let select = event.currentTarget,
        wrapper = select.closest('.js-step--wrapper'),
        url = select.value;
    wrapper.classList.add('loading');
    const filterDataUrl = element => element.url === url;

    this.catchFilter.some(filterDataUrl) ? this._renderFromCatch(url,select) : this._renderFromFetch(url,select);
  }
  _renderFromCatch(url,select){
    let element = this.catchFilter.find(element => {
      return (element.url === url)
    });
    this._renderFilterData(element.data,select);
  }
  _renderFromFetch(url,select){
    fetch(`${url}?section_id=product-gift-card-collection-products`)
    .then(responce => {
      return responce.text();
    })
    .then(data => {
      this.catchFilter = [...this.catchFilter, { data, url }];
      this._renderFilterData(data,select);
    });
  }
  _renderFilterData(html,select){
    let newHTML = new DOMParser().parseFromString(html, 'text/html'),
        wrapper = select.closest('.js-step--wrapper'),
        button = wrapper.querySelector('.btn-next-prev');
    wrapper.querySelector('card-product-slider').replaceWith(newHTML.querySelector('card-product-slider'));
    button.disabled = true;
    button.classList.add('disabled');
  }
});

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    if (this.form){
      this.form.addEventListener('submit', this.onSubmitHandle.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
    }
  }

  onSubmitHandle(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');
    let cartModel = document.querySelector(`product-card-model[data-product-id="${submitButton.dataset.productId}"]`) || submitButton.closest('product-card-model');

    if(submitButton.hasAttribute('data-collectionurl') == false){
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    }

    if(window.addCandyOnSubmit){
      let productInfoWrapper = document.querySelector(".product__info-wrapper");
      let candySelectionLimit = window.selectionNum ?? 3;
      let childCustomCandyInputs = productInfoWrapper.querySelectorAll("input[type='checkbox']:checked");
      let totalCount = 0;
      childCustomCandyInputs.forEach(function (element) {
        let closestProductContent = element.closest(".product__content");
        if (closestProductContent) {
          let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
          if (candyQtySelector) {
            totalCount += Number(candyQtySelector.value);
          }
        }
      });
      
      if (totalCount < candySelectionLimit) {
        if (productInfoWrapper) {
          let existingError = productInfoWrapper.querySelector(".error-msg-validation");
          let productFormButtons = productInfoWrapper.querySelector(".product-form__buttons");
          if (existingError) existingError.remove();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
      
          // Create and insert the error message
          const errorMsgValidation = document.createElement("div");
          errorMsgValidation.className = "error-msg-validation";
          errorMsgValidation.style.color = "red";
          errorMsgValidation.style.marginTop = "10px";
          errorMsgValidation.textContent = `You must select at least ${candySelectionLimit} candies to purchase this item.`;
      
          productFormButtons.insertAdjacentElement("afterend", errorMsgValidation);
          // Clear after 5 seconds
          setTimeout(() => {
            errorMsgValidation.remove();
          }, 5000);
        }
        return;
      }
    }

    window.submitButtonReplace = submitButton.classList.contains('js-drawer-card');
    
    let body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    let id = this.form.id.value
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      if(productForm.querySelectorAll('.main-id').length){
         productForm.querySelectorAll('.main-id').forEach(function(elm){
           if(elm.value){
             id = elm.value 
           } 
         })
      }
    });

    if(submitButton.hasAttribute('data-collectionurl') == true){
      let productData = {
          id: id,
          quantity: (this.form.quantity) ? this.form.quantity.value : 1,
          productName: submitButton.getAttribute('data-productTitle')
       };
      // console.log("productData", productData)
      window.sessionStorage.setItem("productData", JSON.stringify(productData));
      cartModel._open();
      
      return;
    }
    // console.log("productForms", productForms)
    if(submitButton.hasAttribute('modal-form-cards') == true && window.sessionStorage.getItem("productData") != null){
      let cardsProductData = JSON.parse(window.sessionStorage.getItem("productData")),
          currentProductData = JSON.parse(serializeForm(this.form)),
          items = {},
          curentTime = new Date().getTime();
      if(currentProductData.properties){
        currentProductData.properties._uniq_id = curentTime;
      } else{
        currentProductData.properties = {};
        currentProductData.properties._uniq_id = curentTime;
      }
      currentProductData.properties.for = cardsProductData.productName;

      let shipping_interval_unit_type = document.querySelector('[name="properties[shipping_interval_unit_type]"]') ? document.querySelector('[name="properties[shipping_interval_unit_type]"]').value : '';
      let shipping_interval_frequency = document.querySelector('[name="properties[shipping_interval_frequency]"]') ? document.querySelector('[name="properties[shipping_interval_frequency]"]').value : '';
      if(shipping_interval_unit_type && shipping_interval_frequency){
        // currentProductData.properties.shipping_interval_unit_type = shipping_interval_unit_type 
        // currentProductData.properties.shipping_interval_frequency = shipping_interval_frequency 
      }
      let selling_plan = document.querySelector("select[name='selling_plan']") ? document.querySelector("select[name='selling_plan']").value : '';

      items.items = [
        currentProductData,
        {
          id: cardsProductData.id,
          quantity: cardsProductData.quantity,
          selling_plan: selling_plan,
          properties: {
            _main_product: curentTime,
            With:submitButton.form.querySelector('[name="id"]:checked').dataset.title,
            shipping_interval_unit_type: shipping_interval_unit_type, 
            shipping_interval_frequency: shipping_interval_frequency
          }
        }
      ];

      // console.log("items.items===", items.items)

      const sectionStepFourElements = document.querySelectorAll(".section-step-four");
      sectionStepFourElements.forEach(sectionStepFour => {
        if (window.getComputedStyle(sectionStepFour).display !== 'none') {
          let quantityInputs = sectionStepFour.querySelectorAll(".added-message");
          quantityInputs.forEach(quantityInput => {
            if (window.getComputedStyle(quantityInput).display !== 'none') {
              let idInput = quantityInput.parentElement.querySelector('input[name="id"]');
              let id = idInput.value;
              let quantity = 1;
              // let properties = {'_upsell' : true};
              let properties = {'_upsell' : true, 'For': cardsProductData.productName, '_uniq_var_id': curentTime}
              items.items.push({ id, quantity, properties });
            }
          });
        }
      });

      if(window.addCandyOnSubmit){
        let upsellArray = [];
        window.candyVariantIds.forEach(id => {
          let idExists = upsellArray?.some(product => product.id === id);
          if(!idExists){
            let candyQty = 1;
            let candyQtySelector = document.querySelector(`[name="candy__qty--selector-${id}"]`);
            if(candyQtySelector){
              candyQty = Number(candyQtySelector.value);
            }
            let obj = {
              'id': id,
              'quantity': candyQty,
              'properties' : {'_upsell' : true, 'For': cardsProductData.productName, '_uniq_var_id': curentTime, '_eligible_candy' : true}
            }
            upsellArray.push(obj)
          }
          if(window.specificUpsellData == null){
            window.specificUpsellData = upsellArray;
          }else{
            window.specificUpsellData = [...window.specificUpsellData, ...upsellArray];
          }
        });
      }
      
      if (window.specificUpsellData && window.specificUpsellData.length > 0) {
        let propertiesData = {
          '_upsell': true,
          'For': cardsProductData.productName,
          '_uniq_var_id': curentTime
        };
      
        window.specificUpsellData.forEach(obj => {
          let objId = obj?.id;
          let foundObject = items.items?.find(item => item.id == objId);
          if(foundObject){
            let updateData = {
              quantity: foundObject?.quantity ?? 2
            };
            Object.assign(foundObject, updateData);
          }else{
            if (!obj.properties) {
              obj.properties = {};
            }
            Object.assign(obj.properties, propertiesData);
            items.items.push({ ...obj });
          }
          
        });
      }
      

      items.sections = this.getSectionsToRender().map((section) => section.section);
      items.sections_url = window.location.pathname;
      body = JSON.stringify(items);

    }

       
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        /*fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
            var setsproductcount = 0;
            var flowerCount = 0;
            const cartItems = cartData.items;
            cartItems.forEach(item => {
            const { product_id, title, price, quantity, handle } = item;
            if(handle == 'the-fresh-set' || handle == 'the-candle' || handle == 'the-perfume' || handle == 'the-hand-cream'){
              setsproductcount++;
            }
            if(handle == 'the-send' || handle == 'tulips' || handle == 'roses' || handle == 'lilies'){
              flowerCount++;
            }
            })
            document.querySelectorAll('.product__list-container .product-grid__item').forEach((item) => {
              let findButton = item.querySelector('product-form button'),
                  findCollectionSingle = findButton.getAttribute('collection-collectionsingle'),
                  findCollectionFreshset = findButton.getAttribute('collection-collectionfreshset'),
                  findCollectionFlowers = findButton.getAttribute('collection-collectionflowers')
              if(setsproductcount > 0 && findCollectionSingle == 'false' && findCollectionFreshset == 'false'){
                findButton.setAttribute('disabled','disabled')
              }
            if(flowerCount > 0 && findCollectionFlowers == 'false'){
                findButton.setAttribute('disabled','disabled')
              }
            })
        })
        .catch(error => {
          console.log('Error fetching cart data:', error);
        });*/
        // console.log("parsedState", parsedState)
        if(parsedState?.status == 422){
          appendErrorTextMsg(parsedState?.description);
        }else{
          
          this.getSectionsToRender().forEach((section => {
            // console.log("section.section", parsedState?.sections[section.section])
            // console.log("section.selector", section.selector)
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          })); 
        }
        
    
        
      })
      .catch((e) => {
        console.error("error", e);
        // appendErrorTextMsg(e.);
        
      })
      .finally(() => {
        window.updateCartAttribute();
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        // this.cartDrawer.open();
        if(cartModel) cartModel._close(true);
        window.sessionStorage.removeItem("productData");
        window.sessionStorage.removeItem('giftMessage');
        
        fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          
          const cartItems = cartData.items;
          var ShowFreshsetMessage = false;
          var TheCandleAdded = false;
          var ThePerfumeAdded = false;
          var TheHandCreamAdded = false;
          let cartUpdate = {},
              cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          
          cartItems.forEach(item => {
              if (item.product_id === 7186335367204){
                cartUpdate[item.key] = 0;
                  TheCandleAdded = true;
              }
              if (item.product_id === 7186335891492){
                cartUpdate[item.key] = 0;
                  ThePerfumeAdded = true;
              }
              if (item.product_id === 7186335957028){
                cartUpdate[item.key] = 0;
                  TheHandCreamAdded = true;
              }
            
              if(TheCandleAdded == true && ThePerfumeAdded == true){
                ShowFreshsetMessage = true;
              }else if(ThePerfumeAdded == true && TheHandCreamAdded == true){
                ShowFreshsetMessage = true;
              }else if(TheHandCreamAdded == true && TheCandleAdded == true){
                ShowFreshsetMessage = true;
              }
           
          });

          if(ShowFreshsetMessage == true && window.submitButtonReplace == true){
            let items = {
              updates: cartUpdate,
              sections: this.getSectionsToRender().map((section) => section.section)
            };
            
             // console.log('update::',items);
            // return;
            fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(items)
            }).then(function(data) {
              return data.json();
            }).then(responce => {
              this.getSectionsToRender().forEach((section => {
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                if(elementToReplace) elementToReplace.innerHTML = this.getSectionInnerHTML(responce.sections[section.section], section.selector);
            }));
            }).catch(function(error) {
              console.error('Request failed', error)
            })
            .finally(() => {
              window.updateCartAttribute();
              // cart.disableLoading(ele.dataset.index);
              let submitBtn = document.querySelector('.product-form__buttons');
              // console.log("submitBtn", submitBtn)
              if(submitBtn){
                submitBtn.querySelector('.product-form__submit').removeAttribute('disabled');
                submitBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
                submitBtn.querySelector('span').classList.remove('hidden-text');
                window.specificUpsellData = null;
                window.candyVariantIds = [];
                candyInputDeselectListener();
                let giftProductAdded = document.querySelectorAll(".gift__product--added");
                giftProductAdded.forEach(function(ele){
                   ele.classList.remove("gift__product--added");
                });
              }
            });
          }
          var timestamp = new Date().getTime();
          setCookie("cartTimestamp", timestamp, 2);
        })
        .finally(() => {
            window.updateCartAttribute();
            let submitBtn = document.querySelector('.product-form__buttons');
            // console.log("submitBtn", submitBtn)
            if(submitBtn){
              submitBtn.querySelector('.product-form__submit').removeAttribute('disabled');
              submitBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
              submitBtn.querySelector('span').classList.remove('hidden-text');
            }
        })
      });

      if(clickedProductId){
        document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').querySelector('.loading-overlay__spinner').classList.remove('hidden');
        document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').querySelector('span').classList.add('hidden-text');
        document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').disabled = true;
        // var circleElement = document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]').querySelector('.loading-overlay__spinner svg .path');
        // if (circleElement) {
        //     circleElement.style.stroke = '#000';
        // }
      }

      setTimeout(function () {
        let recentlyClidecBtn;
        if(clickedProductId){
          recentlyClidecBtn = document.querySelector('button[type="submit"][data-product-id="'+clickedProductId+'"]');
        }
        getCart(true, recentlyClidecBtn, clickedProductId);
      }, 2000)
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});